import { academizer } from '@application/ai-prompts/academizer/command'

import AiGenerator from '@ui/shared/components/AiGenerator'

const tableFeatures = [
  { feature: `🙌${'\u00A0'} Free for use`, description: 'No payment required, completely free.' },
  {
    feature: `🔒${'\u00A0'} Safe & secure`,
    description: 'Your data is fully encrypted and never stored.',
  },
  {
    feature: `🧑‍🎓${'\u00A0'} Formalize text`,
    description: 'Make your text academic-like without losing the meaning.',
  },
  {
    feature: `✂️${'\u00A0'} Copy & paste`,
    description: "Paste your informal sentences to 'academize' them in seconds!",
  },
]

const faqs = [
  {
    question: 'How are Writefull’s Academizer and Paraphraser different?',
    answer:
      'Both widgets rewrite your sentences, but the Academizer has been trained to make informal language academic, while the Paraphraser rewrites academic sentences into new academic ones. Use the Academizer if you have an idea written in simple language and you want to make it appropriate for your academic text, and use the Paraphraser if you have an academic sentence that you want to rephrase.',
  },
  {
    question: 'How does the Academizer work?',
    answer:
      'Like Writefull’s other widgets, the Academizer uses Artificial Intelligence (AI). We developed a model that converts language from informal to formal. We used a dataset of academic language to train the model, so that the formal language that it generates is suitable for academic texts like essays, papers, and theses.',
  },
  {
    question: 'Is the Academizer free to use?',
    answer:
      'Yes, like all Writefull widgets, you can use it for free. We do have a fair use policy, and we’ll block excessive hits to avoid abuse.',
  },
  {
    question: 'What happens to the sentences I enter into the Academizer?',
    answer:
      'Nothing at all - we don’t store anything. Your text is sent to Writefull’s servers and removed directly after processing. All text sent to and from our servers is also encrypted.',
  },
  {
    question: 'Who made the Academizer?',
    answer:
      'The Academizer was thought of and created by Writefull’s team of experts in AI/NLP and Linguistics. Most of Writefull’s team members used to be researchers, so we know how hard academic writing can be!',
  },
]

const examples = [
  'The results of this study are pretty good, and so other fields should also use them.',
  'This shows that we need to look at what Smith already wrote.',
  "Table 1 shows a lot of numbers, but doesn't really tell us anything.",
  "If we don't validate this approach, we keep doing research that might be crap.",
  'There are lots of ways to do this, but most studies use the egg method.',
]

export default function Academizer() {
  return (
    <AiGenerator
      label='Enter informal text here'
      actions={[
        {
          name: 'Academizer',
          code: 'academizer',
        },
      ]}
      skeleton={{ type: 'text', bars: 2 }}
      faqs={{ faqs, tableFeatures, widgetName: 'Academizer' }}
      examples={examples}
      minLength={50}
      maxLength={2000}
      onGenerate={academizer}
    />
  )
}
